import axios from "axios";
import { API_URL } from "../config/axiosConfig";

export const apiGetPendingWithdrawlRequest = (token) =>
  axios.get(`${API_URL}/v1/transaction/status/PENDING`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

export const apiApproveWithdrawlRequest = (token, transactionId) =>
  axios.post(
    `${API_URL}/v1/transaction/transactionId/${transactionId}/status/APPROVED`,
    {},
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

export const apiGetPendingBatchRequest = (token, status) =>
  axios.get(`${API_URL}/v1/admin/batchStatus/${status}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });


